module.exports = "/v2/pages/dashboard/dist/e0d5d687698acf4a8ad2f80050e41651.svg";